import { BannerNotification } from '@deltasierra/shared';
import { BannerNotificationsSocketService } from '../../sockets';

export default class BannerNotificationDisplayController {
    public static SID = 'BannerNotificationDisplayController';

    public static readonly $inject: string[] = [BannerNotificationsSocketService.SID];

    public constructor(private readonly bannerNotificationsSocketService: BannerNotificationsSocketService) {
        this.dismissBanner = this.dismissBanner.bind(this);
        this.updateBannerHeight = this.updateBannerHeight.bind(this);
    }

    public get currentBannerNotification(): BannerNotification | null {
        return this.bannerNotificationsSocketService.currentBannerNotification;
    }

    public dismissBanner(id: number): void {
        this.bannerNotificationsSocketService.dismissBanner(id);
    }

    public updateBannerHeight(newBannerHeight: number): void {
        this.bannerNotificationsSocketService.updateBannerHeight(newBannerHeight);
    }


    public getClass(): string {
        const bannerNotification = this.currentBannerNotification;

        if (!bannerNotification) {
            return '';
        }

        let base = `alert-${bannerNotification.type}`;

        if (bannerNotification.dismissable) {
            base += ' dismissable';
        }
        return base;
    }
}

angular.module('app').controller(BannerNotificationDisplayController.SID, BannerNotificationDisplayController);
